const mFeedMapsContentModalDelete = {
  mFeedMapsContentModalDelete: {
    alerts: {
      deleteMapa: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'El mapa fue eliminado exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ELIMINAR',

    messageDelete: {
      element: 'Se eliminará el mapa',
      options: 'y todas sus características de forma definitiva.',
      notReversed: 'Esta acción no podrá ser revertida.'
    },

    title: 'Eliminar Mapa'
  }
}

export default mFeedMapsContentModalDelete
